import { MUTATIONS, useMutation } from "../../../api";
import type { WorkshopId, WorkshopParticipant } from "../../../api/workshop";
import { useConfirmAction } from "../../../design-system/primitives/components/AlertDialog/useConfirmAction";

/** The "remove from workshop" confirmation, shared by StudentRow and TeacherRow. */
export const useRemoveFromWorkshop = (
  workshopId: WorkshopId,
  user: WorkshopParticipant,
) => {
  const [doRemoveUser] = useMutation(MUTATIONS.removeUserFromWorkshop);

  return useConfirmAction({
    onConfirm: () => doRemoveUser({ workshopId, userId: user.id }),
    variant: "destructive",
    title: `${user.name} entfernen?`,
    description:
      "Wenn du die Person entfernst, kann die Person nicht mehr auf die Lernreise zugreifen und müsste neu eingeladen werden.",
    errorDescription:
      "Die Person konnte nicht entfernt werden. Bitte versuche es erneut.",
    actionLabel: "Entfernen",
    actionIcon: "x",
  });
};
